var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tags)?_c('div',[_vm._l((_vm.tagList),function(tag,idx){return [_c('el-tag',{key:idx,staticClass:"tag",attrs:{"effect":tag.selected ? 'dark':'plain'},on:{"click":function($event){return _vm.select(tag)}}},[_vm._v(_vm._s(tag.v))])]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }